export default onHydrationEnd;

function onHydrationEnd() {
  const body = typeof document !== 'undefined' && document.querySelector('body');

  body!.classList.add('page-is-interactive');
}
